import { render, staticRenderFns } from "./AllObjectTable.vue?vue&type=template&id=256aa7a0&scoped=true"
import script from "./AllObjectTable.vue?vue&type=script&lang=js"
export * from "./AllObjectTable.vue?vue&type=script&lang=js"
import style0 from "./AllObjectTable.vue?vue&type=style&index=0&id=256aa7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256aa7a0",
  null
  
)

export default component.exports